/**
 * What the audit screen keeps in the address bar: the filters, so a link from another screen
 * ("this person's activity", "what was done in this Emergency session") opens it already filtered,
 * and a reload or the back button keeps them. Kept small: the router loads it with the shell.
 */
export interface AuditSearch {
  readonly from?: string | undefined;
  readonly to?: string | undefined;
  readonly actorId?: string | undefined;
  readonly locationId?: string | undefined;
  readonly entityType?: string | undefined;
  readonly entityId?: string | undefined;
  readonly action?: string | undefined;
  readonly emergency?: true | undefined;
  readonly emergencySessionId?: string | undefined;
}

const DATE = /^\d{4}-\d{2}-\d{2}$/;
const ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const ENTITY_TYPE = /^[a-z][a-z0-9_.]{0,59}$/;
const ACTION = /^[A-Za-z][A-Za-z0-9_.]{0,59}$/;

const text = (value: unknown, pattern: RegExp): string | undefined =>
  typeof value === 'string' && pattern.test(value) ? value : undefined;

export function auditSearch(input: Record<string, unknown>): AuditSearch {
  const entityId =
    typeof input.entityId === 'string' &&
    input.entityId.trim() !== '' &&
    input.entityId.length <= 100
      ? input.entityId.trim()
      : undefined;
  const values: AuditSearch = {
    from: text(input.from, DATE),
    to: text(input.to, DATE),
    actorId: text(input.actorId, ID),
    locationId: text(input.locationId, ID),
    entityType: text(input.entityType, ENTITY_TYPE),
    entityId,
    action: text(input.action, ACTION),
    emergency: input.emergency === true || input.emergency === 'true' ? true : undefined,
    emergencySessionId: text(input.emergencySessionId, ID),
  };
  return Object.fromEntries(Object.entries(values).filter(([, v]) => v !== undefined));
}

/** The API query for these filters (only the ones that are set) and the page cursor. */
export function auditQuery(
  search: AuditSearch,
  cursor?: string | null,
): Record<string, string | undefined> {
  const query: Record<string, string | undefined> = {};
  for (const [key, value] of Object.entries(search)) {
    if (value !== undefined) query[key] = String(value);
  }
  if (cursor) query.cursor = cursor;
  return query;
}
